<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="
      (data.docShareView
        ? 'DOCS_MODULE.DOCUMENT.SELECT_DOCUMENT_SHARE'
        : 'DOCS_MODULE.DOCUMENT.DOCUMENTS_LIST'
      ) | translate
    "
    [viewLoading$]="dataSource?.loading$"
    [class]="'card-head-lg'"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template
          *ngIf="!data.docShareView"
          [ngxPermissionsOnly]="entityId ? null : 'canAddDocument'"
        >
          <button mat-raised-button class="btn btn-primary" (click)="addDocument($event)">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>{{ 'DOCS_MODULE.DOCUMENT.ADD_DOCUMENT' | translate }}</span>
          </button>
        </ng-template>
        <button
          *ngIf="data.docShareView"
          mat-raised-button
          [matTooltip]="'GLOBAL.CLOSE' | translate"
          class="btn btn-icon btn-light"
          (click)="closeDialog($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
            class="svg-icon svg-icon-lg"
          ></span>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.DOCUMENT.ID' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let document">{{ document.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchId">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.ID' | translate }}</mat-label>
              <input
                matInput
                #searchIdInput
                [placeholder]="'DOCS_MODULE.DOCUMENT.ID' | translate"
              />
              <button
                *ngIf="searchIdInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchIdInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.DOCUMENT.NAME' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let document">
            <span
              [matTooltip]="canViewDocument() ? 'View Document' : null"
              [class.clickable]="canViewDocument()"
              (dblclick)="viewDocument($event, document)"
              >{{ document.name }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.NAME' | translate }}</mat-label>
              <input
                matInput
                #searchNameInput
                [placeholder]="'DOCS_MODULE.DOCUMENT.NAME' | translate"
              />
              <button
                *ngIf="searchNameInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchNameInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.DOCUMENT.DESCRIPTION' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let document">{{ document.description }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDescription">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.DESCRIPTION' | translate }}</mat-label>
              <input
                matInput
                #searchDescriptionInput
                [placeholder]="'DOCS_MODULE.DOCUMENT.DESCRIPTION' | translate"
              />
              <button
                *ngIf="searchDescriptionInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchDescriptionInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="category_name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.DOCUMENT.CATEGORY' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let document">{{ document.category?.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchCategory">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchCategoryAutocomplete
              [label]="'DOCS_MODULE.DOCUMENT.CATEGORY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getCategoryAutocomplete"
              [optionFormatter]="formatCategoryOption"
              [valueFormatter]="formatCategoryOption"
              [control]="searchCategoryAutocomplete"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.DOCUMENT.TYPE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let document">{{
            stringUtils.formatEnumString(document.type)
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchType">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.TYPE' | translate }}</mat-label>
              <mat-select #searchTypeSelect multiple>
                <mat-option *ngFor="let type of docTypes" [value]="type">{{
                  stringUtils.formatEnumString(type)
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="entities">
          <mat-header-cell *matHeaderCellDef>{{
            'DOCS_MODULE.DOCUMENT.ENTITIES' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let document">
            <div class="badged-list">
              <span *ngIf="document.entities?.length">{{
                formatEntityValue(document.entities[0])
              }}</span>
              <span
                *ngIf="document.entities?.length > 1"
                [matTooltip]="getEntitiesString(document.entities, 1)"
                matTooltipPosition="above"
                class="num-badge bg-light-primary text-primary"
              >
                {{ document.entities.length - 1 }}+
              </span>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchEntity">
          <mat-header-cell *matHeaderCellDef>
            <kt-general-autocomplete
              #searchEntityAutocomplete
              [label]="'DOCS_MODULE.DOCUMENT.ENTITY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getEntityAutocomplete"
              [optionFormatter]="formatEntityOption"
              [valueFormatter]="formatEntityValue"
              [control]="searchEntityAutocomplete"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="uploadDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.DOCUMENT.CREATED_DATE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let document">{{
            document.upload_date | date : 'MMM dd, yyyy hh:mm a'
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchCreatedDate">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.CREATED_DATE' | translate }}</mat-label>
              <input
                matInput
                #searchCreatedDateInput
                [matDatepicker]="searchCreatedDatePicker"
                [placeholder]="'DOCS_MODULE.DOCUMENT.CREATED_DATE' | translate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="searchCreatedDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #searchCreatedDatePicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="requiresReview">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.DOCUMENT.REVIEW' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let document">
            <span
              style="width: 100px"
              class="label label-lg label-light-{{
                getStatusClass(document.requires_review?.toString(), 'REQUIRE_REVIEW')
              }} label-inline text-center"
            >
              {{ getStatusLabel(document.requires_review?.toString(), 'REQUIRE_REVIEW') }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchRequiresReview">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.REVIEW' | translate }}</mat-label>
              <mat-select
                #searchRequiresReviewSelect
                [placeholder]="'DOCS_MODULE.DOCUMENT.REVIEW' | translate"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Required</mat-option>
                <mat-option value="false">Not Required</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="reviewed">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'DOCS_MODULE.DOCUMENT.REVIEWED' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let document">
            <span
              *ngIf="document.requires_review"
              style="width: 100px"
              class="label label-lg label-light-{{
                getStatusClass(document.reviewed?.toString(), 'REVIEWED')
              }} label-inline text-center"
            >
              {{ getStatusLabel(document.reviewed?.toString(), 'REVIEWED') }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchReviewed">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'DOCS_MODULE.DOCUMENT.REVIEWED' | translate }}</mat-label>
              <mat-select
                #searchReviewedSelect
                [placeholder]="'DOCS_MODULE.DOCUMENT.REVIEWED' | translate"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Reviewed</mat-option>
                <mat-option value="false">Not Reviewed</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let document">
            <ng-template
              *ngIf="!data.docShareView"
              [ngxPermissionsOnly]="entityId ? null : 'canViewDocument'"
            >
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} Document"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewDocument($event, document)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template
              *ngIf="!data.docShareView"
              [ngxPermissionsOnly]="entityId ? null : 'canEditDocument'"
            >
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Document"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="updateDocument($event, document)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template [ngxPermissionsOnly]="entityId ? null : 'canShareDocument'">
              <button
                matTooltip="{{ 'TABLE.SHARE' | translate }} Document"
                [class.w-100]="data.docShareView"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="shareDocument($event, document)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/Communication/Send.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template
              *ngIf="!data.docShareView"
              [ngxPermissionsOnly]="entityId ? null : 'canViewDocumentAccessHistory'"
            >
              <button
                matTooltip="Access History"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="viewAccessHistory($event, document)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/history.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedCols" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarCols"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedCols"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
